import { render, staticRenderFns } from "./customDashboardGaugeChart.vue?vue&type=template&id=33d5317e"
import script from "./customDashboardGaugeChart.vue?vue&type=script&lang=js"
export * from "./customDashboardGaugeChart.vue?vue&type=script&lang=js"
import style0 from "./customDashboardGaugeChart.vue?vue&type=style&index=0&id=33d5317e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports